import React from 'react'
import { AnyStyledComponent } from 'styled-components'
import NavLink from 'src/components/NavLink'
import { NavSubMenu, NavIcon, DownCaret, SideCaret, DropDownNav, SideSubNav, NavSubSideMenu } from '../styled'

type NavItem = {
	title: string
	to?: string
	href?: string
	content?: Omit<NavItem, 'content'>[]
}

function NavDropdown({
	title,
	content,
	subMenuStyle
}: {
	title: string
	content: NavItem[]
	subMenuStyle: AnyStyledComponent
}) {
	return (
		<DropDownNav>
			<NavLink primary title={title}>
				{content && <NavIcon as={DownCaret} />}
			</NavLink>
			<NavSubMenu as={subMenuStyle}>
				{content.map((dropdownItem) => {
					const key = `${title}-${dropdownItem.title}`
					if (dropdownItem.content) {
						return (
							<SideSubNav key={`submenu-${dropdownItem.title}`}>
								<NavLink key={key} title={dropdownItem.title} to={dropdownItem.to}>
									{dropdownItem.content && <NavIcon as={SideCaret} />}
								</NavLink>
								<NavSubSideMenu>
									{dropdownItem.content.map((sideLink) => {
										const sideLinkKey = `${dropdownItem.title}-${sideLink.title}`
										if (sideLink.href) {
											return (
												<NavLink key={sideLinkKey}>
													<a
														href={sideLink.href}
														target="_blank"
														rel="noopener noreferrer"
														style={{ textDecoration: 'none', color: 'inherit' }}
													>
														{sideLink.title}
													</a>
												</NavLink>
											)
										}
										return <NavLink key={sideLinkKey} title={sideLink.title} to={sideLink.to} />
									})}
								</NavSubSideMenu>
							</SideSubNav>
						)
					}

					if (dropdownItem.href) {
						return (
							<NavLink key={key}>
								<a href={dropdownItem.href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
									{dropdownItem.title}
								</a>
							</NavLink>
						)
					}

					return <NavLink key={key} title={dropdownItem.title} to={dropdownItem.to} />
				})}
			</NavSubMenu>
		</DropDownNav>
	)
}

export default NavDropdown
